import { Component, Host, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  trigger,
  transition,
  style,
  animate,
  query,
  group,
  state
} from '@angular/animations';
import { OnBoardTransitionService } from 'src/app/_services/on-board-transition.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { OnboardDataService } from 'src/app/_services/on-board-data.service';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { userInfo } from 'os';
import { MixpanelService } from 'src/app/_services/mixpanel.service';
@Component({
    selector: 'app-confirm-company',
    templateUrl: './confirm-company.component.html',
    styleUrls: ['./confirm-company.component.scss'],
    animations: [
        trigger('dotAnim', [
            state('inactive', style({
                transform: 'scale(1)',
                opacity: 0.5
            })),
            state('active', style({
                transform: 'scale(1.2)',
                opacity: 1
            })),
            transition('inactive => active', [
                animate('300ms ease-out')
            ]),
            transition('active => inactive', [
                animate('200ms ease-in')
            ])
        ])
    ],
    standalone: false
})
export class ConfirmCompanyComponent implements OnInit {
  companyForm: UntypedFormGroup;
  companyName: string = '';
  currentStep = 1;
  formData = {
      company: null,
      industry: null,
      featureOptions: null
  }
  submitTouched: boolean;

  constructor(
    private router: Router,
    private transitionService: OnBoardTransitionService,
    private errorUtil: ErrorUtil,
    private onboardDataService: OnboardDataService,
    private auth: AuthenticationService,
    private mixPanelService: MixpanelService
  ) { 
   
  this.companyForm = new UntypedFormGroup({
      'companyName': new UntypedFormControl(null, [Validators.required,Validators.maxLength(255)]),
      
    });
  }

ngOnInit(): void {
  this.formData.company =localStorage.getItem('org_home') || null;
  // Sync to preview on input
  this.companyForm.get('companyName')?.valueChanges.subscribe(value => {
    this.companyName = value;
  });

  const savedName = this.onboardDataService.getCompanyName();
  if (savedName) {
    this.companyForm.patchValue({ companyName: savedName });
  }
  
}
 onSubmitCompanyName() {
  console.log(this.companyForm.value,"------ form value ------");
   this.submitTouched = true;
    if(!this.companyForm.valid){
      for (var i in this.companyForm.controls) {
        console.log(this.companyForm.controls[i])
        this.companyForm.controls[i].markAsTouched();
      }
      this.submitTouched = false;
      return false;
    }
    const companyName = this.companyForm.get('companyName')?.value;
    this.onboardDataService.setCompanyName(companyName);
    localStorage.setItem('org_home', this.companyForm.value.companyName);
    localStorage.setItem('setupOrg_home', this.companyForm.value.companyName);
    
this.getAnalyticsBrowser();

    this.transitionService.startTransition('select-industry');
    // localStorage.setItem('setupOrg_home', companyName);
    //  this.router.navigate(['company-setup'], {
    //   state: { direction: 'forward' }
    // });
  }
  getAnalyticsBrowser() {
    //Mixpanel Event Tracking
    if(localStorage.getItem('packageCode') != null && localStorage.getItem('packageCode') != 'Old'){
      this.mixPanelService.track('w_onboard_setcompany', { propertyName: 'w_onboard_setcompany', method: 'button_click'});
    }
  }

}
